import React from 'react';
import { Box, Grid, Typography, Stack, TextField, InputLabel, Button, MenuItem, FormControl, Select } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FlowChart from './FlowChart';
import Navbar from '../Auth/Navbar';
import { ArrowForward } from '@mui/icons-material';

function FormInfoPersonalPage() {
    const syriaCities = [
        "دمشق", "حلب", "اللاذقية", "حمص", "دير الزور", "الرقة",
        "إدلب", "طرطوس", "حماه", "درعا", "القنيطرة", "السويداء",
        "المصياف", "النبك"
    ];

    return (
        <>
            <Navbar />
            <Stack sx={{ backgroundColor: "#eee", minHeight: "90vh", borderRadius: "6px", py: 4 }} alignItems="center" justifyContent="center">
                <Stack sx={{ backgroundColor: "#FFF", minHeight: "80vh", borderRadius: "6px", width: "85%", p: 4 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={3}>
                            <FlowChart index={1} />
                        </Grid>
                        <Grid item xs={9}>
                            <Typography variant='h5' sx={{ fontWeight: "bold", textAlign: "right", display: 'flex', flexDirection: "row-reverse" }}>
                                <span>-1</span> المعلومات الشخصية
                            </Typography>
                            <form>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField fullWidth label='الاسم الكامل لصاحب العقار' placeholder='قم بادخال اسمك الكامل (اسمك وكنيتك)' variant='outlined' margin='normal' />
                                        <TextField fullWidth label='البريد الإلكتروني' placeholder='قم بادخال بريدك الإلكتروني' variant='outlined' margin='normal' />
                                        <Box mt={2}>
                                            <InputLabel>بلد الإقامة</InputLabel>
                                            <Select label="البلد" fullWidth displayEmpty>
                                                <MenuItem value=""><em>سوريا</em></MenuItem>
                                                {/* Add dynamic options here */}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth label='رقم الموبايل لصاحب العقار' placeholder='قم بادخال رقم الموبايل' variant='outlined' margin='normal' />
                                        <FormControl fullWidth variant="outlined" margin="normal" sx={{ direction: 'rtl' }}>
                                            <InputLabel>الحالة الاجتماعية</InputLabel>
                                            <Select
                                                label="الحالة الاجتماعية"
                                                defaultValue="individual"
                                            >
                                                <MenuItem value="family">عائلة</MenuItem>
                                                <MenuItem value="individual">فرد</MenuItem>
                                                <MenuItem value="special_needs_family">عائلة ذوي الاحتياجات الخاصة</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <Box mt={2}>
                                            <InputLabel>المدينة</InputLabel>
                                            <Select label="المدينة" fullWidth displayEmpty>
                                                <MenuItem value="">
                                                    <em>قم باختيار عنصر من القائمة</em>
                                                </MenuItem>
                                                {syriaCities.map((city, index) => (
                                                    <MenuItem key={index} value={city}>
                                                        {city}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth label='العنوان الحالي' placeholder='قم بادخال عنوانك الحالي' variant='outlined' margin='normal' />
                                        <TextField fullWidth label='العنوان المؤقت' placeholder='قم بادخال عنوانك المؤقت إن وجد' variant='outlined' margin='normal' />
                                    </Grid>
                                </Grid>
                            </form>
                        </Grid>
                    </Grid>
                    <Stack direction={"row"} justifyContent={"end"} alignItems={"center"} sx={{ width: "100%", gap: 2, my: 4 }}>
                            <Link to={"/InputInfoHouse"} className='btnLink' >
                                <ArrowBackIcon sx={{ mt: 1 }} />التالي
                            </Link>
                            <Link to="/" className='LinkbtnBack'>
                                تراجع عن تقديم الطلب
                                <ArrowForward sx={{ mt: 1 }} />
                            </Link>
                        </Stack>
                </Stack>
            </Stack>
        </>
    );
}

export default FormInfoPersonalPage;